













import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Button from '@/apps/open/components/Button'
import { ACCESS_KNOW_URL, priUrlReg } from '@/apps/open/constants'
import { getCorpAuthNotifyUrl, setCorpAuthNotifyUrl } from '@/apps/open/services/app'
import InputFormDialogBody from '@/apps/open/components/DialogBodys/InputForm.vue'
import { onRequestError } from '@/apps/open/utils'
import store from '@/apps/open/store'

@Component({
  components: {
    Button
  },
  data: () => ({
    CORP_AUTH_NOTIFY_DOC_URL: ACCESS_KNOW_URL
  })
})
export default class CompanyAuthCallbackSetting extends Vue {
  title = '企业授权通知地址'
  corpAuthNotifyUrl = ''

  get appId () {
    return this.$route.params.id
  }

  get app () {
    return this.$store.getters['App/appInfo']
  }

  get isSandbox () {
    return this.app.is_sandbox
  }

  get isPrivate () {
    return store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '通知地址格式不正确，请重新输入' } : { type: 'url', message: '通知地址格式不正确，请重新输入' }
    const rules = [
      { required: true, message: '请输入通知地址' },
      urlRule
    ] as any
    if (!this.isSandbox) {
      rules.push({ pattern: /^https:\/\//, message: '通知地址格式不正确，请重新输入' })
    }
    return rules
  }

  showViewDialog () {
    this.$dialog.show({
      title: this.title,
      body: this.corpAuthNotifyUrl,
      buttons: [
        { text: '取消' },
        { text: '修改', type: 'primary', fn: this.showEditDialog }
      ]
    })
  }

  showEditDialog () {
    this.$dialog.show({
      title: `${this.title}配置`,
      body: InputFormDialogBody,
      bodyProps: {
        value: this.corpAuthNotifyUrl,
        rules: this.rules,
        placeholder: `请输入${this.isSandbox ? '' : 'https://开头的'}通知地址`,
        submit: this.submitUrl
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async submitUrl (url: string) {
    try {
      if (url !== this.corpAuthNotifyUrl) {
        await setCorpAuthNotifyUrl(this.appId, url)
        this.$message.success(`${this.title}保存成功`)
        this.load()
      }
    } catch (error) {
      onRequestError(error)
    }
    this.$dialog.close()
  }

  async load () {
    try {
      const res = await getCorpAuthNotifyUrl(this.appId)
      this.corpAuthNotifyUrl = res.data.url
    } catch (error) {
      onRequestError(error)
    }
  }

  mounted () {
    this.load()
  }
}
